export default __webpack_public_path__ + "static/media/icon_interview.69528e24.svg";